import React, {Component, Fragment} from "react";
import './Resource/Stylesheets/Layout.css';
import Sidebar from "./Project/Sidebar";
import {connect} from "react-redux";
import Header from "./Project/Header";
import {updateWindow} from "./Redux/Actions/window";
import {hideSidebar, showSidebar, turnOffSidebarFloatBoat, turnOnSidebarFloatBoat} from "./Redux/Actions/sidebar";
import Base from "./Server/Base";
import {notify, updateBase} from "./Redux/Actions/base";
import Resource from "./Resource";
import Notif from "./Components/Notif";
import App from "./App";
import Socket from "./Socket";
import {Howl} from 'howler';
import Perms from './Perms';
import ManagementDashboard from './Project/ManagementDashboard';
import {Route} from 'react-router-dom';
import Dashboard from './Project/Dashboard';
import PageHospitalIncoming from './Project/Page/PageHospitalIncoming';
import PageHospitalOutgoing from './Project/Page/PageHospitalOutgoing';
import PageReadyProducts from './Project/Page/PageReadyProducts';
import PageReservedProducts from './Project/Page/PageReservedProducts';
import PageReserveLogs from './Project/Page/PageReserveLogs';
import PageDestroyedProducts from './Project/Page/PageDestroyedProducts';
import PageReturnHospitalProducts from './Project/Page/PageReturnHospitalProducts';
import PageReturnOrgProducts from './Project/Page/PageReturnOrgProducts';
import PageHospitalNormRequests from './Project/Page/PageHospitalNormRequests';
import PageHospitalOrgNormRequests from './Project/Page/PageHospitalOrgNormRequests';
import PageHospitalOrgEmerRequests from './Project/Page/PageHospitalOrgEmerRequests';
import PageHospitalIrradiateRequests from './Project/Page/PageHospitalIrradiatedRequests';
import PageHospitalWashRequests from './Project/Page/PageHospitalWashRequests';
import PageSectionOrgEmerRequests from './Project/Page/PageSectionOrgEmerRequests';
import PageSectionWashRequests from './Project/Page/PageSectionWashRequests';
import PageSectionIrradiateRequests from './Project/Page/PageSectionIrradiatedRequests';
import PageSectionComplications from './Project/Page/PageSectionComplications';
import PageSectionNormRequests from './Project/Page/PageSectionNormRequests';
import PageTrackProduct from './Project/Page/PageTrackProduct';
import PageRoles from './Project/Page/PageRoles';
import PageHospitals from './Project/Page/PageHospitals';
import PagePolicies from './Project/Page/PagePolicies';
import PageSections from './Project/Page/PageSections';
import PageUsers from './Project/Page/PageUsers';
import PagePatients from './Project/Page/PagePatients';
import PageSetting from './Project/Page/PageSetting';
import PageUpdateHistory from './Project/Page/PageUpdateHistory';
import PageGridTest from './Project/Page/PageGridTest';
import ENVErrors from './Project/ENVErrors';
import PageDoctors from "./Project/Page/PageDoctors";
import PageOrgIncoming from "./Project/Page/PageOrgIncoming";
import PageOrgComplications from "./Project/Page/PageOrgComplications";
import PageOrgNormRequests from "./Project/Page/PageOrgNormRequests";
import PageOrgEmerRequests from "./Project/Page/PageOrgEmerRequests";
import PageOrgWashRequests from "./Project/Page/PageOrgWashRequests";
import PageOrgIrradiateRequests from "./Project/Page/PageOrgIrradiateRequests";

class Layout extends Component {
    constructor(props) {
        super(props);

        this.ref = {
            main: React.createRef(),
            raychat: React.createRef()
        };

        if (!this.checkUserLogin()) {
            props.history.push(Resource.ROUTE.LOGIN);
        }

        // I forced to open socket here in order to access context inside other components didMount Events
        const socket = new Socket({
            token: this.props.user?.sessionGUID
        });

        socket.connect()
            .then(_ => {
                this.props.updateBase({onlineSocket: true});
            })
            .catch(_ => {
                this.props.updateBase({onlineSocket: false});
            });
        socket.onReceiveNotification(data => {
            if (data) {
                const notifications = [];
                const notifConfig = {
                    icon: Resource.IMAGE.PACK.FILE.GREEN,
                    theme: 'prompt',
                    audio: false,
                    duration: 5
                };
                //play sound
                const sound = new Howl({
                    src: [Resource.AUDIO.NOTIFICATION1]
                });
                sound.play();

                for (const item of data) {
                    notifications.push({key: item.Notification, count: item.Count});
                    switch (item.Notification) {
                        case'AwaitingSectionNormRequest':
                            new Notif({
                                ...notifConfig,
                                message: 'درخواست فرآورده عادی دارید.',
                                onClick: _ => {
                                    props.history.push(Resource.ROUTE.HOSPITAL.NORM_REQUESTS + Resource.HASH.AWAITING_HOSPITAL_NORM_REQUESTS);
                                }
                            }).show();
                            break;
                        case'AwaitingSectionEmgRequest':
                            new Notif({
                                ...notifConfig,
                                message: 'درخواست فرآورده اورژانسی دارید.',
                                onClick: _ => {
                                    props.history.push(Resource.ROUTE.HOSPITAL.EMER_REQUESTS + Resource.HASH.AWAITING_HOSPITAL_EMER_REQUESTS);
                                }
                            }).show();
                            break;
                        case'AwaitingHospitalEmgRequest':
                            new Notif({
                                ...notifConfig,
                                message: 'درخواست فرآورده اورژانسی از سازمان دارید.',
                                onClick: _ => {
                                    props.history.push(Resource.ROUTE.HOSPITAL.ORG_EMER_REQUESTS + Resource.HASH.AWAITING_HOSPITAL_ORG_EMER_REQUESTS);
                                }
                            }).show();
                            break;
                        case'AwaitingSectionWashedRequest':
                            new Notif({
                                ...notifConfig,
                                message: 'درخواست خون شسته دارید.',
                                onClick: _ => {
                                    props.history.push(Resource.ROUTE.HOSPITAL.WASH_REQUESTS + Resource.HASH.AWAITING_HOSPITAL_WASH_REQUESTS);
                                }
                            }).show();
                            break;
                        case'AwaitingSectionRadiatedRequest':
                            new Notif({
                                ...notifConfig,
                                message: 'درخواست خون اشعه‌دیده دارید.',
                                onClick: _ => {
                                    props.history.push(Resource.ROUTE.HOSPITAL.IRRADIATE_REQUESTS + Resource.HASH.AWAITING_HOSPITAL_IRRADIATE_REQUESTS);
                                }
                            }).show();
                            break;
                        default:
                            console.log('%cWRONG NOTIFICATION STRUCTURE', 'font-size:25px;color:red;', item);
                            break;
                    }
                }

                this.props.notify(notifications);
            }
        });

        this.state = {
            socket
        };
    }

    componentDidMount() {
        this.updateWindowSize();

        if (window.ENV.DEBUG_MOOD)
            console.log(Perms());

        if (this.checkUserLogin()) {
            Base.init({hospitalId: this.props.user.hospitalId})
                .then(list => {
                    this.props.updateBase(list);
                })
                .catch(message => {
                    new Notif({message, theme: 'error'}).show();
                });
        }

        // if (Perms().DASHBOARD.SHOW_MINISTRY_DASHBOARD) {
        //     this.props.showSidebar();
        // }
    }

    componentWillUnmount() {
        this.state.socket.disconnect();
    }

    render() {
        const mainCls = ['main'];

        this.props.sidebar.floatBoat && mainCls.push('sidebar-float');
        this.props.sidebar.show && mainCls.push('sidebar-show');

        return <Fragment>
            <Header/>
            <section ref={this.ref.main} className={mainCls.join(' ')}>
                <section className="content">
                    <ENVErrors/>

                    {/*{Perms().DASHBOARD.SHOW_MINISTRY ?*/}
                    {/*    <ManagementDashboard/> :*/}
                    {/*    <React.Fragment>*/}
                    <Route path={Resource.ROUTE.DASHBOARD} exact component={ManagementDashboard}/>
                    <Route path={Resource.ROUTE.HOME} exact component={Dashboard}/>

                    <Route path={Resource.ROUTE.ORG.INCOMING} exact component={PageOrgIncoming}/>
                    <Route path={Resource.ROUTE.ORG.NORM_REQUESTS} exact component={PageOrgNormRequests}/>
                    <Route path={Resource.ROUTE.ORG.EMER_REQUESTS} exact component={PageOrgEmerRequests}/>
                    <Route path={Resource.ROUTE.ORG.WASH_REQUESTS} exact component={PageOrgWashRequests}/>
                    <Route path={Resource.ROUTE.ORG.IRRADIATE_REQUESTS} exact component={PageOrgIrradiateRequests}/>
                    <Route path={Resource.ROUTE.ORG.COMPLICATION} exact component={PageOrgComplications}/>

                    <Route path={Resource.ROUTE.HOSPITAL.INCOMING} exact component={PageHospitalIncoming}/>
                    <Route path={Resource.ROUTE.HOSPITAL.OUTGOING} exact component={PageHospitalOutgoing}/>
                    <Route path={Resource.ROUTE.HOSPITAL.READY} exact component={PageReadyProducts}/>
                    <Route path={Resource.ROUTE.HOSPITAL.RESERVED} exact component={PageReservedProducts}/>
                    <Route path={Resource.ROUTE.HOSPITAL.RESERVE_LOG} exact component={PageReserveLogs}/>
                    <Route path={Resource.ROUTE.HOSPITAL.DESTROYED} exact component={PageDestroyedProducts}/>
                    <Route path={Resource.ROUTE.HOSPITAL.RETURNED_TO_HOSPITAL} exact component={PageReturnHospitalProducts}/>
                    <Route path={Resource.ROUTE.HOSPITAL.RETURNED_TO_ORG} exact component={PageReturnOrgProducts}/>
                    <Route path={Resource.ROUTE.HOSPITAL.NORM_REQUESTS} exact component={PageHospitalNormRequests}/>
                    <Route path={Resource.ROUTE.HOSPITAL.ORG_NORM_REQUESTS} exact component={PageHospitalOrgNormRequests}/>
                    <Route path={Resource.ROUTE.HOSPITAL.ORG_EMER_REQUESTS} exact component={PageHospitalOrgEmerRequests}/>
                    <Route path={Resource.ROUTE.HOSPITAL.IRRADIATE_REQUESTS} exact component={PageHospitalIrradiateRequests}/>
                    <Route path={Resource.ROUTE.HOSPITAL.WASH_REQUESTS} exact component={PageHospitalWashRequests}/>

                    <Route path={Resource.ROUTE.SECTION.NORM_REQUESTS} exact component={PageSectionNormRequests}/>
                    <Route path={Resource.ROUTE.SECTION.ORG_EMER_REQUESTS} exact component={PageSectionOrgEmerRequests}/>
                    <Route path={Resource.ROUTE.SECTION.WASH_REQUESTS} exact component={PageSectionWashRequests}/>
                    <Route path={Resource.ROUTE.SECTION.IRRADIATE_REQUESTS} exact component={PageSectionIrradiateRequests}/>
                    <Route path={Resource.ROUTE.SECTION.COMPLICATION} exact component={PageSectionComplications}/>

                    <Route path={Resource.ROUTE.TRACK_PRODUCT} exact component={PageTrackProduct}/>

                    <Route path={Resource.ROUTE.CONFIGURATION.ROLES} exact component={PageRoles}/>
                    <Route path={Resource.ROUTE.CONFIGURATION.HOSPITAL_POLICIES} exact component={PagePolicies}/>
                    <Route path={Resource.ROUTE.CONFIGURATION.HOSPITALS} exact component={PageHospitals}/>
                    <Route path={Resource.ROUTE.CONFIGURATION.SECTIONS} exact component={PageSections}/>
                    <Route path={Resource.ROUTE.CONFIGURATION.DOCTORS} exact component={PageDoctors}/>
                    <Route path={Resource.ROUTE.CONFIGURATION.USERS} exact component={PageUsers}/>

                    <Route path={Resource.ROUTE.PATIENT} exact component={PagePatients}/>

                    <Route path={Resource.ROUTE.SETTINGS} exact component={PageSetting}/>

                    <Route path={Resource.ROUTE.UPDATE_HISTORY} exact component={PageUpdateHistory}/>

                    <Route path={'/test'} exact component={PageGridTest}/>
                    {/*</React.Fragment>}*/}
                </section>
                <Sidebar/>
            </section>
        </Fragment>;
    }

    checkUserLogin() {
        if (!this.props.user.login_at) // if user not login
            return false;
        else if ((this.props.user.save === false && this.props.user.sessionId !== App.session.get('sessionId', null))) { // if user login but check save checkbox
            return false;
        }
        return true;
    }

    updateWindowSize() {
        this.props.updateWindow({
            width: window.innerWidth,
            height: window.innerHeight
        });

        if (window.innerWidth < 800) {
            this.props.turnOnSidebarFloatBoat();
            this.props.hideSidebar();
        } else
            this.props.turnOffSidebarFloatBoat();
    }
}

const mapStateToProps = state => {
    return {
        sidebar: state.sidebar,
        user: state.user
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateWindow: props => dispatch(updateWindow(props)),
        showSidebar: _ => dispatch(showSidebar()),
        hideSidebar: _ => dispatch(hideSidebar()),
        turnOnSidebarFloatBoat: _ => dispatch(turnOnSidebarFloatBoat()),
        turnOffSidebarFloatBoat: _ => dispatch(turnOffSidebarFloatBoat()),
        updateBase: props => dispatch(updateBase(props)),
        notify: (notifications) => dispatch(notify(notifications))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);